import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-491b7984"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "error-color"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconwenti"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconwenti"
}, null, -1));

const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 2,
  class: "success-color"
};
const _hoisted_6 = {
  key: 3,
  class: "error-color"
};
const _hoisted_7 = {
  class: "operate"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 0,
  style: {
    "font-size": "12px",
    "width": "168px"
  }
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "邮", -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "箱", -1));

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ： ");

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服", -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微", -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "信", -1));

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" ： ");

const _hoisted_18 = {
  key: 1,
  style: {
    "font-size": "12px",
    "width": "270px"
  }
};
const _hoisted_19 = {
  style: {
    "cursor": "pointer",
    "color": "#2C79F7"
  }
};
const _hoisted_20 = {
  class: "dialogHeader height18"
};
const _hoisted_21 = {
  class: "title fl font18 bold title-color"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconclose-01"
}, null, -1));

const _hoisted_23 = [_hoisted_22];
const _hoisted_24 = {
  class: "pl20 pr20"
};
const _hoisted_25 = {
  class: "inl-block label-color"
};
const _hoisted_26 = {
  class: "mr10 label-color1"
};
const _hoisted_27 = {
  class: "inl-block label-color"
};
const _hoisted_28 = {
  class: "label-color1"
};
const _hoisted_29 = {
  class: "inl-block label-color"
};
const _hoisted_30 = {
  class: "label-color1"
};
const _hoisted_31 = {
  key: 0,
  class: "error-color"
};
const _hoisted_32 = {
  key: 1
};
const _hoisted_33 = {
  key: 2,
  class: "success-color"
};
const _hoisted_34 = {
  key: 3,
  class: "error-color"
};
const _hoisted_35 = {
  class: "inl-block label-color"
};
const _hoisted_36 = {
  class: "label-color1"
};
const _hoisted_37 = {
  class: "inl-block label-color"
};
const _hoisted_38 = {
  class: "label-color1"
};
const _hoisted_39 = {
  class: "inl-block label-color"
};
const _hoisted_40 = {
  class: "label-color1"
};
const _hoisted_41 = {
  class: "height36 lh36 pl9 label-color2 bold"
};
const _hoisted_42 = {
  class: "pl9 height50 lh50"
};
const _hoisted_43 = {
  class: "height36 lh36 pl9 label-color2 bold"
};
const _hoisted_44 = {
  class: "pl9 height50 lh50"
};
const _hoisted_45 = {
  class: "height36 lh36 pl9 label-color2 bold"
};
const _hoisted_46 = {
  class: "pl9 height50 lh50"
};
const _hoisted_47 = {
  key: 0,
  style: {
    "color": "#EC5048"
  }
};
const _hoisted_48 = {
  class: "height36 lh36 pl9 label-color2 bold"
};
const _hoisted_49 = {
  class: "pl9 height50 lh50"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_link = _resolveComponent("el-link");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

  const _component_el_descriptions = _resolveComponent("el-descriptions");

  const _component_el_dialog = _resolveComponent("el-dialog");

  const _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
    "cell-class-name": _ctx.cellClassName,
    "header-row-class-name": "tableHeader",
    data: _ctx.dataList,
    style: {
      "width": "100%"
    },
    height: _ctx.computedHeight
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "order_no",
      label: _ctx.$t('Order Number'),
      width: "200"
    }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "payment_type",
      label: _ctx.$t('Payment method'),
      width: "195"
    }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "order_amount",
      label: _ctx.$t('Price'),
      width: "170"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.currency === 'RMB' ? '￥' : '$') + " " + _toDisplayString(scope.row.order_amount || '-'), 1)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "pay_time",
      label: _ctx.$t('Date of Purchase'),
      width: "200"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.pay_time ? scope.row.pay_time.substr(0, 10) : '-'), 1)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "pay_status",
      label: _ctx.$t('Status'),
      width: "235"
    }, {
      default: _withCtx(scope => [scope.row.trade_status == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_1, [_createTextVNode(_toDisplayString(_ctx.$t("Refunded")) + " ", 1), _ctx.lang != 'zh' ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        effect: "light",
        content: "<span class='refunded-tip'>Reason: <a>Limit one purchase per person.</a></span>",
        "raw-content": ""
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 1,
        effect: "light",
        content: "<span class='refunded-tip'>原因: <a>每人限购一次。</a></span>",
        "raw-content": ""
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      }))])) : scope.row.trade_status == 0 && scope.row.payment_type === 'company_pay' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("Manual confirmation in progress...")), 1)) : scope.row.pay_status == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("Successful")), 1)) : scope.row.pay_status == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("Failed")), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "address",
      label: _ctx.$t('Operation'),
      width: "180"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tooltip, {
        placement: "top"
      }, {
        content: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("View order details")), 1)]),
        default: _withCtx(() => [_createElementVNode("i", {
          class: "iconfont icondetails-01 pointer colorMain",
          onClick: $event => _ctx.viewDetail(scope.row.order_no)
        }, null, 8, _hoisted_8)]),
        _: 2
      }, 1024), scope.row.trade_status == 0 && scope.row.payment_type === 'company_pay' ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        placement: "bottom",
        effect: "light"
      }, {
        content: _withCtx(() => [_ctx.lang == 'zh' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_row, {
          gutter: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 7,
            style: {
              "display": "flex",
              "justify-content": "space-between"
            }
          }, {
            default: _withCtx(() => [_hoisted_10, _hoisted_11]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 1
          }, {
            default: _withCtx(() => [_hoisted_12]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 16
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              style: {
                "cursor": "pointer",
                "color": "#2C79F7"
              },
              onClick: _cache[0] || (_cache[0] = $event => _ctx.copyKey('gobysec@gmail.com'))
            }, "gobysec@gmail.com")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 7,
            style: {
              "display": "flex",
              "justify-content": "space-between"
            }
          }, {
            default: _withCtx(() => [_hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 1
          }, {
            default: _withCtx(() => [_hoisted_17]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 16
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              style: {
                "cursor": "pointer",
                "color": "#2C79F7"
              },
              onClick: _cache[1] || (_cache[1] = $event => _ctx.copyKey('gobyteam'))
            }, "gobyteam")]),
            _: 1
          })]),
          _: 1
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_row, {
          gutter: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 14,
            style: {
              "text-align": "right"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('E-mail')) + "： ", 1)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 10
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              style: {
                "cursor": "pointer",
                "color": "#2C79F7"
              },
              onClick: _cache[2] || (_cache[2] = $event => _ctx.copyKey('gobysec@gmail.com'))
            }, "gobysec@gmail.com")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 14,
            style: {
              "text-align": "right"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Customer service WeChat')) + "： ", 1)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 10
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              style: {
                "cursor": "pointer",
                "color": "#2C79F7"
              },
              onClick: _cache[3] || (_cache[3] = $event => _ctx.copyKey('gobyteam'))
            }, "gobyteam")]),
            _: 1
          })]),
          _: 1
        })]))]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("Contact us")), 1)]),
        _: 1
      })) : scope.row.pay_status == 0 ? (_openBlock(), _createBlock(_component_el_link, {
        key: 1,
        type: "primary",
        onClick: $event => _ctx.pay(scope.row.order_no, scope.row.payment_type, scope.row.license_type_price)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("Pay Now")), 1)]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  }, 8, ["cell-class-name", "data", "height"])), [[_directive_loading, _ctx.loading]]), _createVNode(_component_el_pagination, {
    currentPage: _ctx.page,
    "onUpdate:currentPage": _cache[4] || (_cache[4] = $event => _ctx.page = $event),
    "page-size": _ctx.size,
    "onUpdate:page-size": _cache[5] || (_cache[5] = $event => _ctx.size = $event),
    small: false,
    disabled: false,
    layout: "prev, pager, next, jumper",
    total: _ctx.total,
    onCurrentChange: _ctx.init,
    class: "fr page"
  }, null, 8, ["currentPage", "page-size", "total", "onCurrentChange"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.dialogVisible = $event),
    "show-close": false,
    title: _ctx.$t('Order details'),
    width: "839px",
    id: "orderDetail",
    ref: "orderDetailDom"
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("Order details")), 1), _createElementVNode("div", {
      class: "fr close pointer",
      onClick: _cache[6] || (_cache[6] = $event => _ctx.dialogVisible = false)
    }, _hoisted_23)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_descriptions, {
      column: "1"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("Order Number")) + " : ", 1)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.currOrder.order_no || '-'), 1), _createElementVNode("i", {
          class: "iconfont iconcopy-01 pointer colorMain font13im",
          onClick: _cache[7] || (_cache[7] = $event => _ctx.copyKey(_ctx.currOrder.order_no || ''))
        })]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("Transaction Number")) + " : ", 1)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.currOrder.outer_trade_no || '-'), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("Status")) + " : ", 1)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_30, [_ctx.currOrder.trade_status == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t("Refunded")), 1)) : _ctx.currOrder.trade_status == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t("Manual confirmation in progress...")), 1)) : _ctx.currOrder.pay_status == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t("Payment successful")), 1)) : _ctx.currOrder.pay_status == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t("Payment Failed")), 1)) : _createCommentVNode("", true)])]),
        _: 1
      }), _ctx.currOrder.trade_status == 4 ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
        key: 0
      }, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("Reason")) + " : ", 1)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_36, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Limit one purchase per person.")), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("Price")) + " : ", 1)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.currOrder.currency === 'RMB' ? '￥' : '$') + _toDisplayString(_ctx.currOrder.order_amount), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, null, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("Date of Purchase")) + " : ", 1)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.currOrder.pay_time || '-'), 1)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_descriptions, {
      column: "4",
      direction: "vertical",
      class: "orderDescriptions"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
        width: "100px"
      }, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("Product types")), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.currOrder.license_type_name || '-'), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        width: "100px"
      }, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("Quantity")), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.currOrder.quantity), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        width: "100px"
      }, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("Term of validity")), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_createTextVNode(_toDisplayString(_ctx.dateComputed(_ctx.currOrder.period)) + " ", 1), _ctx.currOrder.period_day ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(` + ${_ctx.currOrder.period_day} ${_ctx.$t("days")}`), 1)) : _createCommentVNode("", true)])]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        width: "100px"
      }, {
        label: _withCtx(() => [_createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("Price")), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.currOrder.currency === 'RMB' ? '￥' : '$') + " " + _toDisplayString(_ctx.currOrder.order_amount), 1)]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["modelValue", "title"])], 64);
}